// extracted by css-extract-rspack-plugin
export default {"cls1":"Timer-cls1_zRK","cls2":"Timer-cls2_s3h Timer-cls1_zRK","top":"Timer-top_MnV","topBack":"Timer-topBack_cec","bottom":"Timer-bottom_uBf"};